export default "images/mask.png";